// extracted by css-extract-rspack-plugin
export default {"container":"CommentsSection-module__container__Ce9vc","heading":"CommentsSection-module__heading__KmkKs","controlsRow":"CommentsSection-module__controlsRow__EjOwa"};